module.exports = __webpack_public_path__ + "mainassets/img/inno_main.fa5fd40b.jpg";